var $, perflibLoader;

perflibLoader = require('../../src/frontend/core/perflibLoader');

perflibLoader();

$ = window.$ = window.jQuery = require('jquery');

require('../../src/frontend/core/jquery.safe-ready')($);

require('../../src/frontend/core/jquery.addons')($);

require('./groupon_modules/placeholder_field')($);

require('./common/core_libraries');

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2xzLWNvcmUtdk1JTk9SX1YuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2xzLWNvcmUtdk1JTk9SX1YuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsYUFBQSxHQUFnQixPQUFBLENBQVEsdUNBQVI7O0FBQ2hCLGFBQUEsQ0FBQTs7QUFDQSxDQUFBLEdBQUksTUFBTSxDQUFDLENBQVAsR0FBVyxNQUFNLENBQUMsTUFBUCxHQUFnQixPQUFBLENBQVEsUUFBUjs7QUFDL0IsT0FBQSxDQUFRLDJDQUFSLENBQUEsQ0FBcUQsQ0FBckQ7O0FBQ0EsT0FBQSxDQUFRLHVDQUFSLENBQUEsQ0FBaUQsQ0FBakQ7O0FBQ0EsT0FBQSxDQUFRLHFDQUFSLENBQUEsQ0FBK0MsQ0FBL0M7O0FBQ0EsT0FBQSxDQUFRLHlCQUFSIn0=
